import { useSelector } from 'react-redux';
import _get from 'lodash/get';
import { selectMinimalThreshold, selectThreshold } from '../poolStats.selectors';

type useThresholdProps = {
  coin: string;
}

export const useThreshold = (props: useThresholdProps) => {
  const { coin } = props;
  const threshold = useSelector((state) => selectThreshold(state, coin));
  const minimalThreshold = useSelector((state) => selectMinimalThreshold(state, coin));
  return {
    threshold,
    minOrDefaultThreshold: minimalThreshold || threshold || 0,
    minimalThreshold,
  }
}

export default useThreshold;
